module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Victoria-S3.39d8fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Victoria-S3.jpg
// module id = Ki7+
// module chunks = 0